import React from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';

const alertComponentHelper = message => {
    return (
        <Box sx={{ margin: 3 }}>
            <Alert severity="info" sx={{ alignItems: 'center', fontSize: '0.95rem' }}>
                {message}
            </Alert>
        </Box>
    );
};

const InfoAlertDeprecatedEntities = ({ clientGrouping, assigneeData }) => {
    const concatenateNames = items => {
        return items
            ? items
                  .filter(item => item.deprecated)
                  .map(item => item.name)
                  .join(', ')
            : null;
    };
    // Get concatenated names for each type
    const salesRepNames = concatenateNames(clientGrouping.sales_rep);
    const partnerNames = concatenateNames(clientGrouping.partner);
    const advertiserNames = concatenateNames(clientGrouping.advertiser);

    // Create alerts for each type if names exist
    const alerts = [];
    if (salesRepNames) {
        alerts.push(
            alertComponentHelper(`The following Sales Reps have been deprecated: ${salesRepNames}`)
        );
    }
    if (partnerNames) {
        alerts.push(
            alertComponentHelper(`The following Partners have been deprecated: ${partnerNames}`)
        );
    }
    if (advertiserNames) {
        alerts.push(
            alertComponentHelper(
                `The following Advertisers have been deprecated: ${advertiserNames}`
            )
        );
    }

    if (assigneeData?.deprecated) {
        alerts.push(alertComponentHelper(`The assigned user ${assigneeData.name} is deprecated.`));
    }

    // Return all alerts
    return <>{alerts}</>;
};

export default InfoAlertDeprecatedEntities;
